import React from 'react';
import ReactTooltip from 'react-tooltip';
import { TitleCard,
        MaintainabilityLabel,
        ReadabilityLabel,
        ValueSection
} from './MetricsHelpfullComponents';

const MaintainabilityCard = (props) => {

    const{
        metricsData
    }=props;

    const title = 'Maintainability Index';
    const tooltipMessage = 'It measures the extend to which <br/> a software component is <br/> maintainable based on its <br/> complexity, size <br/> and level of documentation' 

    return(
        <div style={{width: '28%'}} >
            <TitleCard title ={title} tooltipMessage={tooltipMessage} />
            <div style={{padding: '1rem',border: 'solid',borderWidth: '0px', borderBottomLeftRadius: '0.5rem', borderBottomRightRadius: '0.5rem', boxShadow: '0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)'}}>
                <ValueSection score={metricsData !== undefined ? metricsData.metricsScores.complexity.ESCOMP_MI.avgScore : 0} value ={metricsData !== undefined ? metricsData.HighLevelMetrics.MI : '-'} />

                {metricsData !== undefined && metricsData.metricsRecommendations.ESCOMP_MI.affectedPercetange > 0 &&
                    <div style={{display: 'flex', flexDirection: 'column', marginTop: '1rem'}}>
                        <span style={{display: 'flex', justifyContent: 'center'}}> <span style={{color: '#0c4d82'}}>{metricsData !== undefined ? metricsData.metricsRecommendations.ESCOMP_MI.files.length: 0} file{metricsData !== undefined && metricsData.metricsRecommendations.ESCOMP_MI.files.length === 1 ? '' :'s'} </span>  &nbsp;fall below recommended value (100)</span>
                        <span style={{display: 'flex', justifyContent: 'center'}}> Affects &nbsp;<span style={{color: '#00ccc4'}}>{metricsData !== undefined ? metricsData.metricsRecommendations.ESCOMP_MI.affectedPercetange :0}% </span>&nbsp; of source code.</span>
                    </div>
                }

                <div style={{display: 'flex', flexDirection: 'column', marginTop: '2.5rem'}}>
                    <span style={{display: 'flex', justifyContent: 'center'}}> Try to reduce the complexity of the</span>
                    <span style={{display: 'flex', justifyContent: 'center'}}> implementation along with providing better</span>
                    <span style={{display: 'flex', justifyContent: 'center'}}> documentation. Splitting complex methods into</span>
                    <span style={{display: 'flex', justifyContent: 'center'}}> multiple ones each serving a certain functionality</span>
                    <span style={{display: 'flex', justifyContent: 'center'}}> and thus minimizing the length of their</span>
                    <span style={{display: 'flex', justifyContent: 'center'}}> vocabulary leads to more maintainable code.</span>
                </div>

                { metricsData !== undefined && metricsData.metricsRecommendations.ESCOMP_MI.affectedPercetange === 0 &&
                        <div style={{display: 'flex', flexDirection: 'column', marginTop: '1rem'}}>
                            <span>&nbsp;</span>
                            <span>&nbsp;</span>
                        </div>    
                }

                <div style={{display: 'flex', justifyContent: 'end', marginTop: '2rem'}}>
                    <ReadabilityLabel/>
                    <MaintainabilityLabel/>
                    <ReactTooltip place='left' effect='solid' />
                    
                </div>
            </div>
        </div>
    )

}

export default MaintainabilityCard;